import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import * as signalR from '@microsoft/signalr';
import { HttpTransportType } from '@microsoft/signalr';
import { v4 as uuidv4 } from 'uuid';

@Injectable({ providedIn: 'root' })
export abstract class SocketService {
  protected abstract url: string;
  protected abstract listenersToClose: string[];

  private readonly hubConfig = {
    skipNegotiation: false,
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () => this.keycloakService.getToken(),
    headers: {
      'x-request-id': uuidv4(),
    },
  };

  protected hubConnection: signalR.HubConnection;

  protected constructor(protected keycloakService: KeycloakService) {
  }

  protected connect(): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.url, this.hubConfig)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Error)
      .build();
  }


  closeConnection(): void {
    if (!this.hubConnection) {
      return;
    }

    for (const listenerName of this.listenersToClose) {
      this.hubConnection.off(listenerName);
    }

    this.hubConnection
      .stop()
      .catch((err) => console.error('Błąd przy zamykaniu połączenia SignalR: ', err));
  }
}
